import { useEffect, useState } from 'react'
import { SidebarImport } from './Import'
import * as Icons from 'lucide-react'
const { PerfectScrollbar, logo, Menu, Link, ConfigProvider, Drawer, useNavigate, useLocation, useDispatch, useSelector, sidebar, SessionManager } = SidebarImport

export default function Sidebar(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props

    const [loading, setLoading] = useState(true)
    const [stateOpenKeys, setStateOpenKeys] = useState(['0'])
    const [selectedKeys, setSelectedKeys] = useState([])
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const data = []
    const data = useSelector(state => state?.sidebar?.data)
    const user = JSON.parse(SessionManager.getSession("user"))
    // console.log(user, 'user')
    // console.log(data)

    const DynamicIcon = ({ iconName, ...props }) => {
        const IconComponent = Icons[iconName];

        if (!IconComponent) {
            // Handle cases where the icon name doesn't exist
            return <span>Icon not found</span>;
        }

        return <IconComponent {...props} />;
    }

    // const item = data?.Permissions?.map((parent, p_index) => (
    //     {
    //         key: p_index.toString(),
    //         icon: <DynamicIcon iconName={parent.icon} size={18} />,
    //         label: parent?.module_name,
    //         children: parent?.masterAction?.map((child, c_index) =>
    //             // child?.permissionAttributes?.action_attributes && JSON.parse(child?.permissionAttributes?.action_attributes)
    //             child?.companyPermissionAttributes?.action_attributes && JSON.parse(child?.companyPermissionAttributes?.action_attributes)
    //                 .filter(fil => fil.show_in_menu === true)
    //                 .map((action, a_index) => (
    //                     {
    //                         key: p_index.toString() + c_index.toString() + a_index.toString(),
    //                         icon: <DynamicIcon iconName={'CircleDot'} size={16} />,
    //                         label: <Link to={action?.route}>{action?.sub_action_name}</Link>,
    //                     }
    //                 )
    //                 )).flat()
    //     }
    // ))

    const item = data?.Permissions?.map((parent, p_index) => (
        {
            key: p_index.toString(),
            icon: <DynamicIcon iconName={parent.icon} size={18} />,
            label: parent?.module_name,
            children: parent?.masterAction?.map((child, c_index) => {

                // 1. Define the permission source based on the role ID.
                //    We check child?.role_id (you might need to adjust the path to role_id)
                const permissionSource = (user?.role_id === 2)
                    ? child?.companyPermissionAttributes
                    : child?.permissionAttributes;

                // 2. Use the dynamically selected permissionSource for the rest of the logic.
                return (
                    permissionSource?.action_attributes && JSON.parse(permissionSource.action_attributes)
                        .filter(fil => fil.show_in_menu === true)
                        .map((action, a_index) => (
                            {
                                key: p_index.toString() + c_index.toString() + a_index.toString(),
                                icon: <DynamicIcon iconName={'CircleDot'} size={16} />,
                                label: <Link to={action?.route}>{action?.sub_action_name}</Link>,
                            }
                        )
                        )
                );

            }).flat()
        }
    ));

    const getLevelKeys = (items1) => {
        const key = {};
        const func = (items2, level = 1) => {
            items2?.forEach((item) => {
                if (item?.key) {
                    key[item.key] = level;
                }
                if (item?.children) {
                    func(item.children, level + 1);
                }
            });
        };
        func(items1);
        return key;
    };

    const levelKeys = getLevelKeys(item);

    const onOpenChange = (openKeys) => {
        const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
        // open
        if (currentOpenKey !== undefined) {
            const repeatIndex = openKeys
                .filter((key) => key !== currentOpenKey)
                .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
            setStateOpenKeys(
                openKeys
                    // remove repeat key
                    .filter((_, index) => index !== repeatIndex)
                    // remove current level all child
                    .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
            );
        } else {
            // close
            setStateOpenKeys(openKeys);
        }
    };

    // Handle menu item click - close drawer on mobile/tablet when clicking a link
    const handleMenuClick = (e) => {
        // Check if the clicked item is a leaf node (has no children, meaning it's a link)
        const clickedItem = findMenuItemByKey(item, e.key);
        if (clickedItem && !clickedItem.children && isMobileOrTablet) {
            // Close the drawer when a link is clicked on mobile/tablet
            setDrawerOpen(false);
        }
    };

    // Helper function to find menu item by key
    const findMenuItemByKey = (items, targetKey) => {
        for (const item of items || []) {
            if (item.key === targetKey) {
                return item;
            }
            if (item.children) {
                const found = findMenuItemByKey(item.children, targetKey);
                if (found) return found;
            }
        }
        return null;
    };

    const sidebar_res = (res) => {
        if (res && res.status === 200) {
            setLoading(false)
            const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
        } else {
            setLoading(false)
        }
    }


    useEffect(() => {
        // Derive selected and open keys from current URL
        const pathName = location?.pathname || ''
        let computedSelectedKey = null
        let computedOpenKey = null

        item?.forEach((parent) => {
            parent?.children?.forEach((child) => {
                const route = child?.label?.props?.to
                if (!route) return
                if (pathName === route || pathName.startsWith(route + '/')) {
                    computedSelectedKey = child?.key
                    computedOpenKey = parent?.key
                }
            })
        })

        if (computedSelectedKey) {
            setSelectedKeys([computedSelectedKey])
        }
        if (computedOpenKey) {
            setStateOpenKeys([computedOpenKey])
        }
    }, [location?.pathname, data])


    useEffect(() => {
        setLoading(true)
        dispatch(sidebar({ navigate })).then((res) => sidebar_res(res.payload))
    }, [])

    return (
        <>
            {!isMobileOrTablet && (
                <div className={collapsed ? 'sidebar_collapsed' : 'sidebar_notCollapsed'}>

                    <div className='sidebar_header'>
                        <img src={logo} className='img-fluid' alt="logo" />
                    </div>

                    <ConfigProvider
                        theme={{
                            components: {
                                Menu: {
                                    itemSelectedColor: '#0E5482',
                                    subMenuItemSelectedColor: '#0E5482',
                                    itemBg: 'transparent',
                                    itemHoverBg: 'rgba(14, 84, 130, 0.08)',
                                    itemHoverColor: '#0E5482',
                                    itemSelectedBg: '#E7F1F8',
                                    itemColor: '#2A3F4D',
                                    popupBg: '#FFFFFF'
                                },
                            },
                            token: {
                                fontFamily: 'Lexend Deca',
                                fontSize: 13
                            },
                        }}
                    >
                        <PerfectScrollbar className="sidebar_menu_scroll">
                            <Menu
                                mode="inline"
                                inlineCollapsed={collapsed}
                                selectedKeys={selectedKeys}
                                openKeys={stateOpenKeys}
                                onOpenChange={onOpenChange}
                                items={item}
                                style={{ backgroundColor: 'transparent', paddingBottom: 16 }}
                                triggerSubMenuAction="click"
                            />
                        </PerfectScrollbar>
                    </ConfigProvider>
                </div>
            )}

            {isMobileOrTablet && (
                <Drawer
                    title={<img src={logo} className='img-fluid' alt="logo" style={{ height: 32 }} />}
                    placement="left"
                    closable
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                    width={280}
                    zIndex={2000}
                    styles={{
                        body: { padding: 0, background: "#F7FBFD", overflow: 'hidden' },
                        header: { background: "#FFFFFF", borderBottom: '1px solid #DCE7EF' },
                        footer: { background: "#F7FBFD" },
                        mask: { backgroundColor: 'rgba(14, 84, 130, 0.28)' }
                    }}
                >
                    <div className="sidebar_drawer_body">
                    <ConfigProvider
                        theme={{
                            components: {
                                Menu: {
                                    itemSelectedColor: '#0E5482',
                                    subMenuItemSelectedColor: '#0E5482',
                                    itemBg: 'transparent',
                                    itemHoverBg: 'rgba(14, 84, 130, 0.08)',
                                    itemHoverColor: '#0E5482',
                                    itemSelectedBg: '#E7F1F8',
                                    itemColor: '#2A3F4D',
                                    popupBg: '#FFFFFF'
                                },
                            },
                            token: {
                                fontFamily: 'Lexend Deca',
                                fontSize: 13
                            },
                        }}
                    >
                        <PerfectScrollbar className="sidebar_menu_scroll">
                            <Menu
                                mode="inline"
                                selectedKeys={selectedKeys}
                                openKeys={stateOpenKeys}
                                onOpenChange={onOpenChange}
                                onClick={handleMenuClick}
                                items={item}
                                style={{ backgroundColor: 'transparent', paddingBottom: 16 }}
                                triggerSubMenuAction="click"
                            />
                        </PerfectScrollbar>
                    </ConfigProvider>
                    </div>
                </Drawer>
            )}
        </>
    )
}